import React, { Component } from 'react';
import App from 'grommet/components/App';
import Box from 'grommet/components/Box';
import Common from './Common';
import $ from 'jquery';

class MyApp extends Component {

  constructor(){
    super();
    this.state={ };
  }

  componentDidMount()
  {
    $("title").text("HPE ESP Online Sizers");
  }
  render() {
    return (
       
    <App centered={false}>
      <Box id="everything" className="everything" > 
        <Box id="content" >
            <Box id="header" className="header"></Box>
            <Common/>
              
            <Box id="footer" className="footer"></Box>
        </Box>
      </Box>
    </App>
    
    );
  }
}

export default MyApp;



// WEBPACK FOOTER //
// ./src/MyApp.js